// This file can be removed once parent component app/views/admin/notaries/index.html.haml is migrated to react
import { AdminNotariesBoard } from './AdminNotariesBoard'

export default AdminNotariesBoard
